/*
 * contact-page.js — behaviour for the contact page's bands (sections/contact-help.liquid, sections/contact-us-form.liquid).
 * 1. Chat / Call buttons ([data-cu-action="chat" | "call"]) open the Zendesk messenger, as the storewide call bar
 *    (snippets/live-call-annbar.liquid) does: zE('messenger', 'show'), then zE('messenger', 'open') for chat or
 *    zE('messenger:open', 'voice', <line id>) for a call.
 *    On a phone, a call dials the number for the visitor's country (data-cu-tel-us / data-cu-tel-gb, country from
 *    assets/moasure-call-number.js) when there is one. No local number, or country not known yet: the free Zendesk
 *    call, so nobody is put off by an international charge. If Zendesk hasn't loaded (blocked or slow), the buttons
 *    go to data-cu-fallback (the contact form) instead, so the customer is never stuck.
 *    Each click is logged like the bar's: PostHog "Opened Call/Chat Widget", and call_bar_click in the dataLayer
 *    (location "contact-page", method tel | webrtc) so calls from here sit beside the bar's in GA4.
 * 2. Old #DP--… links to the previous form scroll to the new one (#contact-form).
 * (The thank-you redirect after sending is inline in sections/contact-us-form.liquid, so it runs before the page draws.)
 * Loaded deferred by both sections. The browser fetches it once but RUNS it once per <script> tag, so the guard below
 * stops a second copy: two click handlers asked Zendesk for two calls per click, and it answered "Call failed".
 */
(function () {
  if (window.moContactPage) return;
  window.moContactPage = true;

  // Touch-first device = a phone or tablet that can dial (not a width check: a narrow desktop window is still a desktop)
  var canDial = !!(window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);

  // The visitor's local number, or '' (country unknown, or no number for it)
  function localNumber(button) {
    var country = document.documentElement.getAttribute('data-mo-call-country') ||
      (window.moCallNumber ? window.moCallNumber.cachedCountry() : '');
    var tel = country ? button.getAttribute('data-cu-tel-' + country.toLowerCase()) : '';
    return (tel || '').replace(/\s+/g, '');
  }

  function track(kind, method) {
    try {
      if (window.posthog && window.posthog.capture) {
        window.posthog.capture(kind === 'call' ? 'Opened Call Widget' : 'Opened Chat Widget', { Context: 'Contact page', Method: method });
      }
    } catch (error) {}
    if (kind === 'call') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'call_bar_click', location: 'contact-page', method: method });
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cu-action]');
    if (!button) return;
    var kind = button.dataset.cuAction;
    var tel = kind === 'call' && canDial ? localNumber(button) : '';
    if (tel) {
      track('call', 'tel');
      window.location.href = 'tel:' + tel;
      return;
    }
    track(kind, kind === 'call' ? 'webrtc' : 'messenger');
    try {
      if (typeof window.zE !== 'function') throw new Error('Zendesk not loaded');
      window.zE('messenger', 'show');
      if (kind === 'call' && button.dataset.cuVoiceLine) {
        window.zE('messenger:open', 'voice', button.dataset.cuVoiceLine);
      } else {
        window.zE('messenger', 'open');
      }
    } catch (error) {
      goTo(button.dataset.cuFallback); // no Zendesk: take the customer to the form instead
    }
  });

  function goTo(link) {
    if (!link) return;
    var target = link.charAt(0) === '#' ? document.getElementById(link.slice(1)) : null;
    if (target) target.scrollIntoView({ behavior: 'smooth' });
    else window.location.href = link;
  }

  // Old links to the Design Packs form (/pages/contact-us#DP--template--…, from the chatbot and Instant pages) land on the new form
  var form = document.getElementById('contact-form');
  if (form && window.location.hash.indexOf('#DP--') === 0) form.scrollIntoView();
})();
